import React from 'react';
import Loader from './Loader';

/** Higher-order component which switches out a component for a loading spinner when requested */
export default function withLoading(WrappedComponent) {
  return (props) => {
    const component = props.isLoading ? <Loader /> : <WrappedComponent {...props} />
    return (
      <div className="chart-container">
        {component}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/withLoading.js